import { render, staticRenderFns } from "./cannotOutput.vue?vue&type=template&id=472a6778&scoped=true"
import script from "./cannotOutput.vue?vue&type=script&setup=true&lang=js"
export * from "./cannotOutput.vue?vue&type=script&setup=true&lang=js"
import style0 from "./cannotOutput.vue?vue&type=style&index=0&id=472a6778&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472a6778",
  null
  
)

export default component.exports